import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewEncapsulation, Input } from '@angular/core';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { Actions, ofActionCompleted, Select, Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { ViewActions } from '../../state/view.actions';
import { ViewState } from '../../state/view.state';
import { ViewUIStatus } from '../../models/view-ui-status.enum';
import { NodeActions } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { EngineState } from 'src/app/engine/state/engine.state';
import { QueryNodeInfoSuccess, QueryNodeInfoFailure, SetNodeInfo } from 'src/app/engine/state/engine.actions';
import { ViewLayout } from '../../models/view-layout';

@Component({
  selector: 'app-view-node-description',
  templateUrl: './view-node-description.component.html',
  styleUrls: ['./view-node-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewNodeDescriptionComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------


  @Select(EngineState.getQuerying)
  querying$: Observable<boolean>;






  // ---------- Input / Output ----------
  @Input()
  layout: ViewLayout = ViewLayout.Drawer;

  @Input()
  showClose = true;


  isOpen = false;

  node: ViewTreeNode;


  // ---------- Class Variables ----------
  private ngUnsubscribe = new Subject();

  

  // ---------- Lifecycle ----------
  constructor(
    private store: Store,
    private actions: Actions, 
    private changeRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initInfoListeners();

    this.store.select(EngineNodesState.getSelectedNode).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(node => {
      if (node !== undefined) {
        this.node = this.store.selectSnapshot(EngineState.getViewGraphNode)(node.objectId);
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // ---------- Interaction ----------
  handleHideClick(node: ViewTreeNode) {
    this.store.dispatch(new NodeActions.UpdateNodesShown(
      false,
      [node.id]
    ));
  }

  handleCloseClick() {
    const layout = this.store.selectSnapshot(ViewState.getUI);
    layout.nodeInfo.status = ViewUIStatus.Hide;
    this.store.dispatch(new ViewActions.SetUI(layout));
  }



  // ---------- Methods ----------
  initInfoListeners() {
    // mark "dirty" check for node updates
    this.actions
      .pipe(
        ofActionCompleted(
          QueryNodeInfoSuccess,
          QueryNodeInfoFailure,
          SetNodeInfo
        ),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this.isOpen = true;
        this.changeRef.markForCheck();
      });
  }

  formatHTML(text: string): string {
    return text
      .trim()
      .replace(new RegExp('\r?\n', 'g'), '<br><br>');
  }
}
